import { render, staticRenderFns } from "./User_profile_edit.vue?vue&type=template&id=ccf9b5ea&"
import script from "./User_profile_edit.vue?vue&type=script&lang=js&"
export * from "./User_profile_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports